import chartjs from 'chart.js';
import chartjsannotation from 'chartjs-plugin-annotation';

export function registerTextAnnotationPaint() {
    //we only want to register this once.
    Chart.pluginService.register({
        beforeDraw: function (chart) {
            var ctx = chart.chart.ctx;

            ctx.restore();
            //this outputs the "Normal Range Text"

            ctx.font = Chart.helpers.fontString(14, 'bold', Chart.defaults.global.defaultFontFamily);
            ctx.textAlign = "center";
            ctx.textBaseline = "bottom";
            let line = chart.chart.annotation.elements.hline1;

            //ctx.fillStyle = '#444444';
            ctx.fillText("Reference Range", line._model.x1 + 60, line._model.y1 + 20);

            ctx.save();
        }
    });
}